<template>
	<inertia-head title="Unread Notifications" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Unread Notifications</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Unread Notifications List
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">
		<div class="block block-rounded">
			<div class="block-content block-content-full">
				<div v-if="unReadNotifications.length === 0">
					<div class="alert alert-warning">
						<p class="mb-0 fw-semibold">
							No Notifications Found
						</p>
					</div>
				</div>
				<div v-else>
					<div class="table-responsive">
						<button @click="markAllAsRead" type="button" class="btn btn-success btn-sm">Mark all as read</button>
						<table class="table table-striped table-borderless table-vcenter fs-sm">
							<thead>
								<tr>
									<th>Title</th>
									<th class="text-end">Posted Date</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(notify, index) in unReadNotifications.data" :key="notify.id">
									<td nowrap="">
										<a @click="readNotification(index)" href="javascription:void(0)" class="fw-bold text-info" title="View the details">{{notify.data.title}}</a>
										<div>
											<sub>
												{{notify.data.short_desc}}
											</sub>
										</div>
									</td>
									<td class="text-end">{{notify.created_at}}</td>
								</tr>
								<tr v-if="unReadNotifications.data.length == 0">
									<td colspan="2">
										<p class="m-2 fw-semibold text-center text-danger">NO RECORD FOUND</p>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import { onMounted, ref, watch } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import AuthLayout from '../../Layouts/AuthLayout';

export default {
	layout: AuthLayout,
	props: {
		unReadNotifications : Object
	},
	setup(props) {
		
		const readNotification = (_index)=>{
			var notification = props.unReadNotifications.data[_index];
			var id = notification.id;
			var notify_link = notification.data.link;

			axios.get('/api/read/notification/'+id)
			   	.then(res => {
			      if(res.data.result=="success")
			      {
			      	Inertia.visit(notify_link,{ method: 'get' });
			      }else
			      {
			      	console.log("Failed");
			      }
			   	})
		}

		const markAllAsRead = ()=>{
			axios.get('/api/read/notification/list/all')
			   	.then(res => {
			      if(res.data.result=="success")
			      {
			      	Inertia.visit("unread",{ method: 'get' });
			      }else
			      {
			      	console.log("Failed");
			      }
			   	})
		}

		return{
			readNotification,
			markAllAsRead
		}
	},
}
</script>
